import {
    CLEAR_ONGOING_CONSULTATION_DETAILS,
    FETCH_ONGOING_CONSULTATION_DETAILS_SUCCESS,
    FETCH_VIDEO_ACCESS_TOKEN_SUCCESS,
    UPDATE_CHIEF_COMPLAINTS,
    UPDATE_CURRENT_ALLERGIES,
    UPDATE_CURRENT_PATIENT_GOALS,
    UPDATE_CURRENT_PATIENT_SECONDARY_GOALS,
    UPDATE_CURRENT_PATIENT_INTERVENTIONS,
    UPDATE_CURRENT_PRESCRIPTION,
    UPDATE_EXAMINATIONS,
    UPDATE_ILLNESSES,
    UPDATE_MEDICAL_PROFILE,
    UPDATE_PAST_CONDITIONS,
    SAVE_REVIEW_OF_SYSTEMS_DATA,
    UPDATE_MENTAL_STATUS_EXAMINATIONS,
    GET_UI_CONFIGURATION,
    UPDATE_PATIENT_PERSONAL_INFO,
    UPDATE_PATIENT_PLAN,
    UPDATE_SYSTEMIC_EXAMINATIONS,
    UPDATE_CURRENT_PATIENT_TRACKABLE_SYMPTOMS,
    SAVE_FETCHED_USER_METRICS,
    SAVE_ONGOING_CONSULTATION_PRODUCT,
    FETCH_PATIENT_PLAN_ELIGIBILITY_INFO_SUCCESS,
    UPDATE_DIAGNOSTIC_LABTESTS_DETAILS,
    SAVE_EDITED_LAB_TESTS,
    SAVE_PATIENT_DIAGNOSTIC_LAB_TESTS,
    UPDATE_MANUAL_LABTESTS_DETAILS,
    SAVE_CONSULTATION_TEMPLATES_RESPONSE,
    UPDATE_CURRENT_CONFIG_MEDICAL_PROFILE,
    UPDATE_PATIENT_NUMBER_FOR_AUDIO_CALL,
    UPDATE_NO_PRESENTING_ILLNESS,
    SAVE_SUB_SECTIONS_RECOMMENDATIONS,
    UPDATE_NEW_CONFIG_DATA,
    UPDATE_SUGGESTIONS_CONSULTATION_DATA,
    UPDATE_CURRENT_CONSULTATION_DATA,
    SUBMIT_CONSULTATION_FEEDBACK_FORM,
    REMOVE_APPLIED_TEMPLATES_ONGOING,
    STORE_APPLIED_TEMPLATES_ONGOING, ADD_USED_SUGGESTION_FOR_EDITOR, SET_ONGOING_CONSULTATION_FITNESS_PLAN,
    SAVE_EXERCISES_FOR_ONGOING_FITNESS_PLAN,
    SET_ONGOING_CONSULTATION_USER_FITNESS_PLAN
} from "../actions/ActionTypes"
import initialState from "./InitialState"
import { ILabtestPrescription, IPrescription } from "@curefit/care-common";
import { get as _get } from "lodash"
import IPatientLifestylePlanWrapper from "../models/patients/IPatientLifestylePlanWrapper";
import AppUtils, { removeFieldsForId } from "../utils/AppUtils";
import { uniq, uniqBy } from "lodash";

export const OngoingConsultationReducer = (state = initialState.ongoingConsultation, action: any) => {
    switch (action.type) {
        case FETCH_ONGOING_CONSULTATION_DETAILS_SUCCESS:
            return {
                ...state,
                uiConfiguration: action.ongoingConsultation && action.ongoingConsultation.uiConfiguration,
                uiTabs: action.ongoingConsultation.uiTabs,
                appointmentSchedule: action.ongoingConsultation.appointmentSchedule,
                currentPrescription: action.ongoingConsultation.currentPrescription,
                medicalProfile: action.ongoingConsultation.medicalProfile,
                patientPersonalProfile: action.ongoingConsultation.patientPersonalProfile,
                patientLabTests: action.ongoingConsultation.patientLabTests,
                patientPlan: action.ongoingConsultation.patientPlan,
                patientGoals: action.ongoingConsultation.patientGoals,
                planMeta: action.ongoingConsultation.planMeta,
                patientTrackableSymptoms: action.ongoingConsultation.patientTrackableSymptoms,
                baseSellableProduct: action.ongoingConsultation.consultationProductName,
                videoContext: action.ongoingConsultation.videoAccessToken,
                patientPlanEligibilityInfo: action.ongoingConsultation.patientPlanEligibilityInfo,
                diagnosticLabTests: action.ongoingConsultation.diagnosticLabTests,
                manualLabTests: [],
                pdfTemplates: {},
                suggestions: {},
                pastPrescriptions: action.ongoingConsultation.pastPrescriptions
            };
        case UPDATE_DIAGNOSTIC_LABTESTS_DETAILS:
            return { ...state, diagnosticLabTests: action.diagnosticLabTests };
        case UPDATE_MANUAL_LABTESTS_DETAILS:
            return { ...state, manualLabTests: action.labTests };
        case CLEAR_ONGOING_CONSULTATION_DETAILS:
            return initialState.ongoingConsultation;
        case UPDATE_CURRENT_PATIENT_GOALS:
            return { ...state, patientGoals: action.patientGoals };
        case SUBMIT_CONSULTATION_FEEDBACK_FORM:
            const submittedConsultationForms = state.submittedConsultationForms || [];
            submittedConsultationForms.push(action.consultationId);
            return {
                ...state,
                submittedConsultationForms
            }
        case UPDATE_CURRENT_PATIENT_SECONDARY_GOALS:
            return { ...state, patientSecondaryGoals: action.patientGoals };
        case UPDATE_CURRENT_PATIENT_INTERVENTIONS:
            return { ...state, patient_interventions: action.patient_interventions };
        case UPDATE_CURRENT_PRESCRIPTION: {
            return { ...state, currentPrescription: action.prescription };
        }
        case UPDATE_CURRENT_ALLERGIES:
            return { ...state, medicalProfile: { ...state.medicalProfile, currentConsultationData: { ...state.medicalProfile.currentConsultationData, allergies: action.allergies } } };
        case UPDATE_CHIEF_COMPLAINTS:
            return { ...state, currentPrescription: { ...state.currentPrescription, patientSymptomSet: action.chiefComplaints } };
        case UPDATE_ILLNESSES:
            return { ...state, currentPrescription: { ...state.currentPrescription, hopi: action.illnesses } };
        case UPDATE_PAST_CONDITIONS:
            return { ...state, medicalProfile: action.medicalProfile };
        case UPDATE_EXAMINATIONS:
            return { ...state, medicalProfile: { ...state.medicalProfile, examinations: action.exams } };
        case UPDATE_SYSTEMIC_EXAMINATIONS:
            return { ...state, medicalProfile: { ...state.medicalProfile, patientSystemicExaminations: action.exams } };
        case UPDATE_MEDICAL_PROFILE:
            return { ...state, medicalProfile: action.medicalProfile };
        case FETCH_VIDEO_ACCESS_TOKEN_SUCCESS:
            return { ...state, videoContext: action.videoAccessToken };
        case UPDATE_PATIENT_PERSONAL_INFO:
            return { ...state, patientPersonalProfile: action.patientPersonalProfile };
        case SAVE_REVIEW_OF_SYSTEMS_DATA:
            return { ...state, medicalProfile: { ...state.medicalProfile, patientSystemReviews: action.payload } };
        case UPDATE_MENTAL_STATUS_EXAMINATIONS:
            return { ...state, medicalProfile: { ...state.medicalProfile, mentalStatusExaminations: action.exams } };
        case UPDATE_PATIENT_PLAN: {
            return { ...state, patientPlan: action.patientPlan };
        }
        case UPDATE_CURRENT_PATIENT_TRACKABLE_SYMPTOMS:
            return { ...state, patientTrackableSymptoms: action.trackableSymptoms };
        case GET_UI_CONFIGURATION:
            return { ...state, uiConfiguration: action.payload }
        case SAVE_FETCHED_USER_METRICS:
            let patientMetrics = state.patientMetrics || {}
            patientMetrics[action.payload.metricId] = action.payload.data;
            return { ...state, patientMetrics };
        case SAVE_ONGOING_CONSULTATION_PRODUCT:
            return { ...state, baseSellableProduct: action.baseSellableProduct };
        case FETCH_PATIENT_PLAN_ELIGIBILITY_INFO_SUCCESS:
            return { ...state, patientPlanEligibilityInfo: action.patientPlanEligibilityInfo };
        case SAVE_EDITED_LAB_TESTS:
            return { ...state, diagnosticLabTests: action.diagnosticLabTests };
        case SAVE_PATIENT_DIAGNOSTIC_LAB_TESTS: {
            const existingDiagnosticLabTests = Object.assign([], state.diagnosticLabTests);
            const newlySavedDiagnosticLabTests = action.patientDiagnosticLabTests;
            return { ...state, diagnosticLabTests: [...existingDiagnosticLabTests, ...newlySavedDiagnosticLabTests] };
        }
        case SAVE_CONSULTATION_TEMPLATES_RESPONSE: {
            return { ...state, pdfTemplates: action.payload }
        }
        case UPDATE_CURRENT_CONFIG_MEDICAL_PROFILE: {
            return { ...state, medicalProfile: { ...state.medicalProfile, currentConfigMedicalProfile: action.medicalProfile } }
        }
        case SAVE_SUB_SECTIONS_RECOMMENDATIONS: {
            return { ...state, suggestions: { ...state.suggestions, ...action.payload } }
        }
        case UPDATE_NEW_CONFIG_DATA: {
            return { ...state, medicalProfile: { ...state.medicalProfile, patientData: { ...state.medicalProfile.patientData, newConfigData: action.newConfigData } } }
        }

        case UPDATE_SUGGESTIONS_CONSULTATION_DATA: {
            return { ...state, suggestions: { ...state.suggestions, treatmentPlan: action.payload } }
        }
        case UPDATE_CURRENT_CONSULTATION_DATA:
            return { ...state, medicalProfile: { ...state.medicalProfile, currentConsultationData: action.medicalProfile } }

        case STORE_APPLIED_TEMPLATES_ONGOING:
            let appliedTemplateIds = state.medicalProfile?.currentConsultationData?.prescriptionTemplateMapping?.templateIds || [];
            const appliedReferenceIds = state.medicalProfile?.currentConsultationData?.prescriptionTemplateMapping?.referenceIds || [];
            appliedTemplateIds = uniq([...appliedReferenceIds, ...appliedTemplateIds]);

            if (!appliedTemplateIds.includes(action.templateId)) {
                appliedTemplateIds.push(action.templateId);
            }
            return {
                ...state,
                medicalProfile: {
                    ...state.medicalProfile,
                    currentConsultationData: {
                        ...state.medicalProfile.currentConsultationData,
                        prescriptionTemplateMapping: {
                            templateIds: uniq(appliedTemplateIds)
                        }
                    }
                }
            }
        case REMOVE_APPLIED_TEMPLATES_ONGOING:
            let newTemplateIds = state.medicalProfile?.currentConsultationData?.prescriptionTemplateMapping?.templateIds || [];

            const removeTemplateIndex = newTemplateIds.indexOf(action.templateId);
            let newCurrentPrescription = state.medicalProfile.currentConsultationData;
            if (removeTemplateIndex !== -1) {
                newTemplateIds.splice(removeTemplateIndex, 1);
                newCurrentPrescription = removeFieldsForId(state.medicalProfile.currentConsultationData, action.templateId);
            }



            let newReferenceIds: string[] = state.medicalProfile?.currentConsultationData?.prescriptionTemplateMapping?.referenceIds || [];
            const removeReferenceIndex = newReferenceIds.indexOf(action.templateId);
            if (removeReferenceIndex !== -1) {
                newReferenceIds = newReferenceIds.filter((id: string) => id !== action.templateId);
                newCurrentPrescription = removeFieldsForId(state.medicalProfile.currentConsultationData, action.templateId);
            }
            newCurrentPrescription.prescriptionTemplateMapping.templateIds = uniq([...newReferenceIds, ...newTemplateIds]);
            newCurrentPrescription.prescriptionTemplateMapping.referenceIds = uniq(newReferenceIds);

            return {
                ...state,
                medicalProfile: {
                    ...state.medicalProfile,
                    currentConsultationData: newCurrentPrescription
                }
            }

        case ADD_USED_SUGGESTION_FOR_EDITOR:
            const subSectionData = _get(state.usedSuggestionsForEditorMap, action.payload.subSectionKey, {})
            const alreadyUsedSuggestions = _get(subSectionData, action.payload.questionKey, [])
            return {
                ...state,
                usedSuggestionsForEditorMap: {
                    ...state.usedSuggestionsForEditorMap,
                    [action.payload.subSectionKey]: {
                        ...subSectionData,
                        [action.payload.questionKey]: [...alreadyUsedSuggestions, action.payload.val]
                    }
                }
            }

        case SET_ONGOING_CONSULTATION_FITNESS_PLAN:
            return {
                ...state,
                fitnessPlan: {
                    ...state.fitnessPlan,
                    userFitnessPlan: action.userFitnessPlan,
                    userFitnessPlanStartDate: action.userFitnessPlanStartDate,
                    isPublishedPlan: action.isPublishedPlan
                }
            }
        case SAVE_EXERCISES_FOR_ONGOING_FITNESS_PLAN:
            return {
                ...state,
                fitnessPlan: {
                    ...state.fitnessPlan,
                    exercises: action.exercises
                }

            }

        case SET_ONGOING_CONSULTATION_USER_FITNESS_PLAN:
            return {
                ...state,
                fitnessPlan: {
                    ...state.fitnessPlan,
                    userFitnessPlan: action.userFitnessPlan
                }
            }
        default:
            return state;
    }
}